/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";

import { useQuery } from "@apollo/client";
import { GET_ALBUMS } from "../../queries";
import { useThemeData } from "../../context/ThemeDataContext";
import AlbumCard from "./albumCard";

/* Album OVERVIEW and photos linking to shop*/
function HomePhotoService(props) {
  const { site_id } = useThemeData().themeData.site;
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageInfo, setPageInfo] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order] = useState({
    order: "DESC",
    field: "folder_id",
  });

  function handleChangePage(event, value) {
    setPage(value);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(event.target.value);
  }

  const {
    loading: loadingAlbums,
    error: errorAlbums,
    data: dataAlbums,
  } = useQuery(GET_ALBUMS, {
    variables: {
      site_id: site_id,
      parent_id: 0,
      page: page + 1,
      first: rowsPerPage,
      orderBy: [order],
    },
  });

  useEffect(() => {
    if (!loadingAlbums && !errorAlbums) {
      if (dataAlbums) {
        let newArray = new Set();
        dataAlbums.albums.data.map(album => {
          console.log(album);
            let item = {
              ...album,
              first_file_name: album.first_file_name === null
                ? album.photos !== null
                      ? album.photos[0].file_name
                      : album.first_file_name
                : null,
                first_photo_id: album.photos !== null
                      ? album.photos[0].id
                  : null,
                first_photo_folder_id: album.photos !== null
                    ? album.photos[0].folder_id
                : null,
            }
            return newArray.add(item);
        });
        let list = Array.from(newArray);
        setData(list);
        setPageInfo(dataAlbums.albums.paginatorInfo);
      }
    }
  }, [errorAlbums, dataAlbums, loadingAlbums]);

  function handleClick(item, open) {
    let location = { pathname: `/login` };
    if (open) {
      location = {
        pathname: `/album/${item.folder_id}`,
        state: { album: item, skipping: false },
      };
    } else {
      location = {
        pathname: `/login`,
        state: { album: item },
      };
    }
    props.history.push(location);
  }

  if (loadingAlbums) return <p>{props.t("Loading...")}</p>;
  if (errorAlbums) return <p>{props.t("Looks like we have a problem...")}</p>;
  if (!data) return null;

  return (
    <>
      <Grid container direction="row" spacing={1}>
        {data.map(album => (
          <Grid item xs={12} sm={8} md={6} lg={4} xl={2} key={album.folder_id}>

            <AlbumCard data={album} handleClick={handleClick}/>
              
          </Grid>
        ))}
      </Grid>

      <TablePagination
        className="overflow-hidden flex-shrink-0"
        component="div"
        count={pageInfo.total ? pageInfo.total : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          "aria-label": "Previous Page",
        }}
        nextIconButtonProps={{
          "aria-label": "Next Page",
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
}

export default React.memo(withTranslation("photos")(HomePhotoService));
